module.exports = __webpack_public_path__ + "img/Prise-Green-Up-Flou-600.6df9d192.png";